import React, { useContext, useEffect, useState } from "react";
import StudentNav from "../Navbars/StudentNav";
import AdminNav from "../Navbars/AdminNav";
import TeacherNav from "../Navbars/TeacherNav";
import GuestNav from "../Navbars/GuestNav";
import { UserContext } from "../UserContext";
import Footer from "../Footer";
import "./ourVision.css";
import { useNavigate } from "react-router-dom";

// Import icons
import aboutIcon from "../../assets/abouticon.png";
import visionIcon from "../../assets/visionicon.png";

const Vision = () => {
  const {
    isAdmin,
    isTeacher,
    isStudent,
    isGuest,
    setUserRole,
    setUserInfo,
    userInfo,
  } = useContext(UserContext);
  const navigate = useNavigate();

  // State for window width
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Update window width on resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      await fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}`, {
        credentials: "include",
      }).then((response) => {
        response
          .json()
          .then((userInfo) => {
            setUserInfo(userInfo);
            if (userInfo?.usertype) {
              setUserRole(userInfo.usertype);
            }
          })
          .catch((err) => console.log("Error in useEffect:", err));
      });
    };
    fetchData();
  }, [isAdmin, isTeacher, isStudent, isGuest]);

  const onLogout = () => {
    fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/logout`, {
      credentials: "include",
      method: "POST",
    });
    setUserInfo(null);
    setUserRole("guest");
    navigate("/");
  };

  const username = userInfo?.username;
  const avatar = userInfo?.avatar;

  // Dynamic image size based on window width
  const getImageSize = () => {
    if (windowWidth < 480) return 120;  // Small screens
    if (windowWidth < 768) return 150;  // Medium screens
    return 200;  // Large screens
  };

  return (
    <>
      {/* Navbar */}
      {username ? (
        <>
          {isAdmin && <AdminNav username={username} avatar={avatar} onLogout={onLogout} />}
          {isTeacher && <TeacherNav username={username} avatar={avatar} onLogout={onLogout} />}
          {isStudent && <StudentNav username={username} avatar={avatar} onLogout={onLogout} />}
        </>
      ) : (
        isGuest && <GuestNav />
      )}

      {/* Page Header with grey background */}
      <div className="page-header" style={{ backgroundColor: '#F0F0F0' }}>
        <div className="container">
          <h1 className="custom-header-title">
            <span className="about-title">Vision for the Future,</span>
            <br />
            <span className="polymath-title">Mission for Today</span>
          </h1>
        </div>
      </div>

      {/* Vision Paragraph */}
      <div className="vision-paragraph-container">
        <img
          src={aboutIcon}
          alt="About Icon"
          className="vision-icon-left"
          style={{ 
            width: `${getImageSize()}px`, 
            height: "auto",
            position: "relative",
            top: "20px",
            left: "20px"
          }}
        />
        <p className="vision-paragraph">
          At Polymath-Kids, we are dedicated to nurturing young minds by inspiring curiosity, creativity, and a passion for learning.
          Our vision is to empower every child to achieve their fullest potential and grow into a confident, compassionate global citizen.
          Through a mission rooted in fostering a growth mindset and developing diverse life skills, we prepare children to face real-world
          challenges with resilience, independence, and innovation.
        </p>
        <img
          src={visionIcon}
          alt="Vision Icon"
          className="vision-icon-right"
          style={{ 
            width: `${getImageSize()}px`, 
            height: "auto",
            position: "relative",
            top: "20px",
            right: "20px"
          }}
        />
      </div>

      {/* Vision Statement */}
      <div className="vision-statement-container">
        <h2 className="vision-heading">Vision Statement</h2>
        <p className="vision-paragraph">
          At Polymath-Kids, we envision a world where every child is empowered to reach their fullest
          potential and grow into a productive, compassionate, and innovative global citizen. We believe
          that by nurturing creativity, critical thinking, and a love for lifelong learning, children can
          become leaders and change-makers who positively impact the world around them. Our vision is to
          build a future where children are not only academically accomplished but also morally grounded,
          socially responsible, and ready to embrace global challenges with confidence and resilience.
        </p>
      </div>

      {/* Mission Statement */}
      <div className="mission-statement-container">
        <h2 className="mission-heading">Mission Statement</h2>
        <div className="mission-paragraph">
          <p>
            At Polymath-Kids, our mission is to inspire and guide young learners to become true polymaths
            — individuals with a passion for acquiring a diverse set of life skills and knowledge across
            multiple fields. We cultivate curiosity, creativity, and a growth mindset through a dynamic
            learning environment that emphasizes exploration, innovation, and real-world application. Through
            a rich variety of programs and global learning opportunities, we aim to develop independent,
            confident learners who are prepared to face the complexities of practical life. By instilling a
            spirit of inquisitiveness and resilience, Polymath-Kids empowers children to build strong
            foundations for personal success, community contribution, and global leadership.
          </p>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Vision;
